if (!customElements.get("color-swatch")) {
  class ColorSwatch extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.optionNodes = this.querySelectorAll("[data-value]");
      this.getVariantData();
      this.initOptionSwatches();
    }

    initOptionSwatches() {
      this.optionNodes.forEach((optNode) => {
        const { optionPosition, value: optionValue } = optNode.dataset;
        const matches = this.variantData.filter(
          (v) =>
            v[`option${optionPosition}`] &&
            v[`option${optionPosition}`].toLowerCase() ===
              optionValue.toLowerCase()
        );
        const variant = matches.find((item) => item.available) || matches[0];
        if (variant) {
          const variantUrl = new URL(optNode.href, window.location.origin);
          variantUrl.searchParams.set("variant", variant.id);
          optNode.href = variantUrl.toString();
        }
      });
    }

    getVariantData() {
      this.variantData =
        this.variantData || JSON.parse(this.nextElementSibling.textContent);
    }
  }
  customElements.define("color-swatch", ColorSwatch);
}
